// extracted by mini-css-extract-plugin
export default {"l_function_icon_main":"FunctionIcon_l_function_icon_main__Dt6Vf","l_function_icon__img":"FunctionIcon_l_function_icon__img__SiVoh"};